import { colors } from "@styles/vars";
import styled from "styled-components";

export default styled.div<{ readOnly?: boolean }>`
    ${props => !props.readOnly && `
        padding: 12px;
        background: ${colors.white};
        transition: .2s ease-out;

        &:hover {
            background: white;
        }
    `}
`